// extracted by mini-css-extract-plugin
module.exports = {"loaderWrap":"CommonLoader_loaderWrap__1RhVz","dotsAnim":"CommonLoader_dotsAnim__1Wb5I","wave":"CommonLoader_wave__25YnQ"};